// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddCompanyAccountForUserData, AddCompanyAccountForUserErrors, AddCompanyAccountForUserResponses, AddFacilitiesForGroupData, AddFacilitiesForGroupErrors, AddFacilitiesForGroupResponses, ChangeHanPortStatusData, ChangeHanPortStatusErrors, ChangeHanPortStatusResponses, ConfirmLinkedAccountInvitationData, ConfirmLinkedAccountInvitationErrors, ConfirmLinkedAccountInvitationResponses, CreateGroupData, CreateGroupErrors, CreateGroupResponses, CreateOrganizationConsumptionReportData, CreateOrganizationConsumptionReportErrors, CreateOrganizationConsumptionReportResponses, CreateOrganizationFacilityReportData, CreateOrganizationFacilityReportErrors, CreateOrganizationFacilityReportResponses, CreateOrganizationInvoiceDetailsReportData, CreateOrganizationInvoiceDetailsReportErrors, CreateOrganizationInvoiceDetailsReportResponses, CreateOrganizationInvoiceReportData, CreateOrganizationInvoiceReportErrors, CreateOrganizationInvoiceReportResponses, CreateReportConfigurationData, CreateReportConfigurationErrors, CreateReportConfigurationResponses, CreateSubGroupData, CreateSubGroupErrors, CreateSubGroupResponses, DeleteFacilitiesForGroupData, DeleteFacilitiesForGroupErrors, DeleteFacilitiesForGroupResponses, DeleteGroupData, DeleteGroupErrors, DeleteGroupResponses, DeleteReportConfigurationData, DeleteReportConfigurationErrors, DeleteReportConfigurationResponses, DeleteUserAccountData, DeleteUserAccountErrors, DeleteUserAccountResponses, DownloadFileData, DownloadFileErrors, DownloadFileResponses, DownloadImdReportsData, DownloadImdReportsErrors, DownloadImdReportsResponses, GetApiV2CustomersByCustomerIdElCostComparisonData, GetApiV2CustomersByCustomerIdElCostComparisonErrors, GetApiV2CustomersByCustomerIdElCostComparisonResponses, GetCardSummaryData, GetCardSummaryErrors, GetCardSummaryResponses, GetCasesData, GetCasesErrors, GetCasesResponses, GetCaseTypesData, GetCaseTypesErrors, GetCaseTypesResponses, GetContractAttachmentPdfData, GetContractAttachmentPdfErrors, GetContractAttachmentPdfResponses, GetContractDetailsData, GetContractDetailsErrors, GetContractDetailsResponses, GetContractPdfData, GetContractPdfErrors, GetContractPdfResponses, GetCostDetailsForInfraserviceSeriesData, GetCostDetailsForInfraserviceSeriesErrors, GetCostDetailsForInfraserviceSeriesResponses, GetCustomerContractsData, GetCustomerContractsErrors, GetCustomerContractsResponses, GetCustomerData, GetCustomerEnergyEfficiencyMeterValuesData, GetCustomerEnergyEfficiencyMeterValuesErrors, GetCustomerEnergyEfficiencyMeterValuesResponses, GetCustomerErrors, GetCustomerFacilitiesData, GetCustomerFacilitiesErrors, GetCustomerFacilitiesResponses, GetCustomerPanelParticipationData, GetCustomerPanelParticipationErrors, GetCustomerPanelParticipationResponses, GetCustomerResponses, GetFacilityExcelReportData, GetFacilityExcelReportErrors, GetFacilityExcelReportResponses, GetGroupData, GetGroupedCustomerContractsData, GetGroupedCustomerContractsErrors, GetGroupedCustomerContractsResponses, GetGroupedCustomerMeterValuesCompareData, GetGroupedCustomerMeterValuesCompareErrors, GetGroupedCustomerMeterValuesCompareResponses, GetGroupedInfraserviceSeriesData, GetGroupedInfraserviceSeriesErrors, GetGroupedInfraserviceSeriesResponses, GetGroupErrors, GetGroupResponses, GetGroupsData, GetGroupsErrors, GetGroupsResponses, GetHanPortsForCustomerData, GetHanPortsForCustomerErrors, GetHanPortsForCustomerResponses, GetHanPortStatusData, GetHanPortStatusErrors, GetHanPortStatusResponses, GetImdReportsData, GetImdReportsErrors, GetImdReportsResponses, GetInfraserviceSeriesAnalysisData, GetInfraserviceSeriesAnalysisErrors, GetInfraserviceSeriesAnalysisResponses, GetInfraserviceSeriesConsumptionReportData, GetInfraserviceSeriesConsumptionReportErrors, GetInfraserviceSeriesConsumptionReportResponses, GetInfraserviceSeriesData, GetInfraserviceSeriesErrors, GetInfraserviceSeriesFromTimeTableData, GetInfraserviceSeriesFromTimeTableErrors, GetInfraserviceSeriesFromTimeTableResponses, GetInfraserviceSeriesReportExcelData, GetInfraserviceSeriesReportExcelErrors, GetInfraserviceSeriesReportExcelResponses, GetInfraserviceSeriesResponses, GetInvitationForUserData, GetInvitationForUserErrors, GetInvitationForUserResponses, GetInvoiceDetailsExcelReportData, GetInvoiceDetailsExcelReportErrors, GetInvoiceDetailsExcelReportResponses, GetInvoiceDocumentData, GetInvoiceDocumentErrors, GetInvoiceDocumentResponses, GetInvoiceReferenceReportExcelData, GetInvoiceReferenceReportExcelErrors, GetInvoiceReferenceReportExcelResponses, GetLinkedAccountInvitationsForCustomerData, GetLinkedAccountInvitationsForCustomerErrors, GetLinkedAccountInvitationsForCustomerResponses, GetLinkedAccountsSummaryForCustomerData, GetLinkedAccountsSummaryForCustomerErrors, GetLinkedAccountsSummaryForCustomerResponses, GetLinkedUserAccountsForCustomerData, GetLinkedUserAccountsForCustomerErrors, GetLinkedUserAccountsForCustomerResponses, GetMonthlyConsumptionOfCustomerReportData, GetMonthlyConsumptionOfCustomerReportErrors, GetMonthlyConsumptionOfCustomerReportResponses, GetOptionsData, GetOptionsErrors, GetOptionsResponses, GetParentOrganizationData, GetParentOrganizationErrors, GetParentOrganizationResponses, GetPeakPowerConsumptionOfMeteringPointData, GetPeakPowerConsumptionOfMeteringPointErrors, GetPeakPowerConsumptionOfMeteringPointResponses, GetPeakPowerCostCalculationData, GetPeakPowerCostCalculationErrors, GetPeakPowerCostCalculationResponses, GetPeakPowerDailyOverviewData, GetPeakPowerDailyOverviewErrors, GetPeakPowerDailyOverviewResponses, GetPeakPowerHourlyOverviewData, GetPeakPowerHourlyOverviewErrors, GetPeakPowerHourlyOverviewResponses, GetReportConfigurationData, GetReportConfigurationErrors, GetReportConfigurationListData, GetReportConfigurationListErrors, GetReportConfigurationListResponses, GetReportConfigurationResponses, GetReportExcelData, GetReportExcelErrors, GetReportExcelResponses, GetReportTemplatesData, GetReportTemplatesErrors, GetReportTemplatesResponses, GetSpecialTimeSeriesReportData, GetSpecialTimeSeriesReportErrors, GetSpecialTimeSeriesReportResponses, GetUserAccountDetailsData, GetUserAccountDetailsErrors, GetUserAccountDetailsLimitedData, GetUserAccountDetailsLimitedErrors, GetUserAccountDetailsLimitedResponses, GetUserAccountDetailsResponses, InviteUsersData, InviteUsersErrors, InviteUsersResponses, PostMessageData, PostMessageErrors, PostMessageResponses, PostMissingValuesMessageData, PostMissingValuesMessageErrors, PostMissingValuesMessageResponses, RemoveLinkedAccountInvitationFromCustomerData, RemoveLinkedAccountInvitationFromCustomerErrors, RemoveLinkedAccountInvitationFromCustomerResponses, RemoveUserAccountsFromCustomerData, RemoveUserAccountsFromCustomerErrors, RemoveUserAccountsFromCustomerResponses, SearchGroupsData, SearchGroupsErrors, SearchGroupsResponses, UpdateAccountDetailsData, UpdateAccountDetailsErrors, UpdateAccountDetailsResponses, UpdateContractInvoiceReferencesData, UpdateContractInvoiceReferencesErrors, UpdateContractInvoiceReferencesResponses, UpdateCustomerAccountDetailsData, UpdateCustomerAccountDetailsErrors, UpdateCustomerAccountDetailsResponses, UpdateCustomerPanelParticipationData, UpdateCustomerPanelParticipationErrors, UpdateCustomerPanelParticipationResponses, UpdateGroupData, UpdateGroupErrors, UpdateGroupResponses, UpdateReportConfigurationData, UpdateReportConfigurationErrors, UpdateReportConfigurationResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Deletes the current user account.
 */
export const deleteUserAccount = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserAccountData, ThrowOnError>) => (options?.client ?? client).delete<DeleteUserAccountResponses, DeleteUserAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account',
    ...options
});

/**
 * Get current user account details, including linked customer accounts if any.
 */
export const getUserAccountDetails = <ThrowOnError extends boolean = false>(options?: Options<GetUserAccountDetailsData, ThrowOnError>) => (options?.client ?? client).get<GetUserAccountDetailsResponses, GetUserAccountDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account',
    ...options
});

/**
 * Update contact details for the current user's own account.
 */
export const updateAccountDetails = <ThrowOnError extends boolean = false>(options?: Options<UpdateAccountDetailsData, ThrowOnError>) => (options?.client ?? client).put<UpdateAccountDetailsResponses, UpdateAccountDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Add a company customer account and link current user account as a user of that account.
 */
export const addCompanyAccountForUser = <ThrowOnError extends boolean = false>(options?: Options<AddCompanyAccountForUserData, ThrowOnError>) => (options?.client ?? client).post<AddCompanyAccountForUserResponses, AddCompanyAccountForUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get a list of all linked user accounts for customer.
 */
export const getLinkedUserAccountsForCustomer = <ThrowOnError extends boolean = false>(options: Options<GetLinkedUserAccountsForCustomerData, ThrowOnError>) => (options.client ?? client).get<GetLinkedUserAccountsForCustomerResponses, GetLinkedUserAccountsForCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}',
    ...options
});

/**
 * Update contact details for a specific customer account linked to the current user.
 */
export const updateCustomerAccountDetails = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerAccountDetailsData, ThrowOnError>) => (options.client ?? client).put<UpdateCustomerAccountDetailsResponses, UpdateCustomerAccountDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}/details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create and send linked account invitation to recipient(s).
 */
export const inviteUsers = <ThrowOnError extends boolean = false>(options: Options<InviteUsersData, ThrowOnError>) => (options.client ?? client).post<InviteUsersResponses, InviteUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}/invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a linked account invitation from current customer.
 */
export const removeLinkedAccountInvitationFromCustomer = <ThrowOnError extends boolean = false>(options: Options<RemoveLinkedAccountInvitationFromCustomerData, ThrowOnError>) => (options.client ?? client).delete<RemoveLinkedAccountInvitationFromCustomerResponses, RemoveLinkedAccountInvitationFromCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}/invitation/{id}',
    ...options
});

/**
 * Get a list of user invitations and status.
 */
export const getLinkedAccountInvitationsForCustomer = <ThrowOnError extends boolean = false>(options: Options<GetLinkedAccountInvitationsForCustomerData, ThrowOnError>) => (options.client ?? client).get<GetLinkedAccountInvitationsForCustomerResponses, GetLinkedAccountInvitationsForCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}/invitations',
    ...options
});

/**
 * Get a summmary of linked accounts and interuption subscriptions
 */
export const getLinkedAccountsSummaryForCustomer = <ThrowOnError extends boolean = false>(options: Options<GetLinkedAccountsSummaryForCustomerData, ThrowOnError>) => (options.client ?? client).get<GetLinkedAccountsSummaryForCustomerResponses, GetLinkedAccountsSummaryForCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}/summary',
    ...options
});

/**
 * Remove linked user account from current customer.
 */
export const removeUserAccountsFromCustomer = <ThrowOnError extends boolean = false>(options: Options<RemoveUserAccountsFromCustomerData, ThrowOnError>) => (options.client ?? client).delete<RemoveUserAccountsFromCustomerResponses, RemoveUserAccountsFromCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/customer/{customerId}/users/{userId}',
    ...options
});

/**
 * Get customer invitation details from user invitation code.
 */
export const getInvitationForUser = <ThrowOnError extends boolean = false>(options: Options<GetInvitationForUserData, ThrowOnError>) => (options.client ?? client).get<GetInvitationForUserResponses, GetInvitationForUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/invitation/{code}',
    ...options
});

/**
 * Confirms a linked account invitation and creates a user account if the user does not already exist.
 */
export const confirmLinkedAccountInvitation = <ThrowOnError extends boolean = false>(options: Options<ConfirmLinkedAccountInvitationData, ThrowOnError>) => (options.client ?? client).post<ConfirmLinkedAccountInvitationResponses, ConfirmLinkedAccountInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/invitation/{code}/confirm',
    ...options
});

/**
 * Get a list of linked customer numbers for the current user account.
 */
export const getUserAccountDetailsLimited = <ThrowOnError extends boolean = false>(options?: Options<GetUserAccountDetailsLimitedData, ThrowOnError>) => (options?.client ?? client).get<GetUserAccountDetailsLimitedResponses, GetUserAccountDetailsLimitedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/account/limited',
    ...options
});

/**
 * Get customer
 */
export const getCustomer = <ThrowOnError extends boolean = false>(options: Options<GetCustomerData, ThrowOnError>) => (options.client ?? client).get<GetCustomerResponses, GetCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}',
    ...options
});

/**
 * Gets a card summary for the current month.
 *
 * Selection contract: at most one `facilityKey` is supported. Omitting `facilityKey` entirely
 * is a valid, implicitly customer-wide request.
 */
export const getCardSummary = <ThrowOnError extends boolean = false>(options: Options<GetCardSummaryData, ThrowOnError>) => (options.client ?? client).get<GetCardSummaryResponses, GetCardSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/cardSummary/{infraService}/currentMonth',
    ...options
});

/**
 * Get active contracts for customer
 */
export const getCustomerContracts = <ThrowOnError extends boolean = false>(options: Options<GetCustomerContractsData, ThrowOnError>) => (options.client ?? client).get<GetCustomerContractsResponses, GetCustomerContractsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/contracts',
    ...options
});

/**
 * Get details for a contract
 */
export const getContractDetails = <ThrowOnError extends boolean = false>(options: Options<GetContractDetailsData, ThrowOnError>) => (options.client ?? client).get<GetContractDetailsResponses, GetContractDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/contracts/{contractId}/details',
    ...options
});

/**
 * Download contractconfirmation attachment PDF
 */
export const getContractAttachmentPdf = <ThrowOnError extends boolean = false>(options: Options<GetContractAttachmentPdfData, ThrowOnError>) => (options.client ?? client).get<GetContractAttachmentPdfResponses, GetContractAttachmentPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/contracts/confirmation/{confirmationId}/attachment/{attachmentId}/download',
    ...options
});

/**
 * Download contract confirmation PDF
 */
export const getContractPdf = <ThrowOnError extends boolean = false>(options: Options<GetContractPdfData, ThrowOnError>) => (options.client ?? client).get<GetContractPdfResponses, GetContractPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/contracts/confirmation/{confirmationId}/download',
    ...options
});

/**
 * Get active contracts for customer grouped by infraservice.
 */
export const getGroupedCustomerContracts = <ThrowOnError extends boolean = false>(options: Options<GetGroupedCustomerContractsData, ThrowOnError>) => (options.client ?? client).get<GetGroupedCustomerContractsResponses, GetGroupedCustomerContractsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/contracts/grouped',
    ...options
});

/**
 * Update invoice references for list of contracts
 */
export const updateContractInvoiceReferences = <ThrowOnError extends boolean = false>(options: Options<UpdateContractInvoiceReferencesData, ThrowOnError>) => (options.client ?? client).put<UpdateContractInvoiceReferencesResponses, UpdateContractInvoiceReferencesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/contracts/invoiceReferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the simulated cost for the electricity consumption of a given month according to the new rules
 *
 * @deprecated
 */
export const getApiV2CustomersByCustomerIdElCostComparison = <ThrowOnError extends boolean = false>(options: Options<GetApiV2CustomersByCustomerIdElCostComparisonData, ThrowOnError>) => (options.client ?? client).get<GetApiV2CustomersByCustomerIdElCostComparisonResponses, GetApiV2CustomersByCustomerIdElCostComparisonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/ElCostComparison',
    ...options
});

/**
 * Get facilities for customer
 */
export const getCustomerFacilities = <ThrowOnError extends boolean = false>(options: Options<GetCustomerFacilitiesData, ThrowOnError>) => (options.client ?? client).get<GetCustomerFacilitiesResponses, GetCustomerFacilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/facilities',
    ...options
});

/**
 * Get groups for customer
 */
export const getGroups = <ThrowOnError extends boolean = false>(options: Options<GetGroupsData, ThrowOnError>) => (options.client ?? client).get<GetGroupsResponses, GetGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups',
    ...options
});

/**
 * Creates a new group
 */
export const createGroup = <ThrowOnError extends boolean = false>(options: Options<CreateGroupData, ThrowOnError>) => (options.client ?? client).post<CreateGroupResponses, CreateGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a group
 */
export const deleteGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteGroupData, ThrowOnError>) => (options.client ?? client).delete<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/{groupId}',
    ...options
});

/**
 * Get group details
 */
export const getGroup = <ThrowOnError extends boolean = false>(options: Options<GetGroupData, ThrowOnError>) => (options.client ?? client).get<GetGroupResponses, GetGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/{groupId}',
    ...options
});

/**
 * Update a group
 */
export const updateGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateGroupData, ThrowOnError>) => (options.client ?? client).put<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/{groupId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes list of facilities for group.
 */
export const deleteFacilitiesForGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteFacilitiesForGroupData, ThrowOnError>) => (options.client ?? client).delete<DeleteFacilitiesForGroupResponses, DeleteFacilitiesForGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/{groupId}/facilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Adds a list of facilities for group.
 */
export const addFacilitiesForGroup = <ThrowOnError extends boolean = false>(options: Options<AddFacilitiesForGroupData, ThrowOnError>) => (options.client ?? client).post<AddFacilitiesForGroupResponses, AddFacilitiesForGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/{groupId}/facilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a subgroup to a group
 */
export const createSubGroup = <ThrowOnError extends boolean = false>(options: Options<CreateSubGroupData, ThrowOnError>) => (options.client ?? client).post<CreateSubGroupResponses, CreateSubGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/{groupId}/subgroups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search groups for customer
 */
export const searchGroups = <ThrowOnError extends boolean = false>(options: Options<SearchGroupsData, ThrowOnError>) => (options.client ?? client).post<SearchGroupsResponses, SearchGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/groups/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists available IMD reports for a given customer
 */
export const getImdReports = <ThrowOnError extends boolean = false>(options: Options<GetImdReportsData, ThrowOnError>) => (options.client ?? client).get<GetImdReportsResponses, GetImdReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/imdreports',
    ...options
});

/**
 * Downloads one or more IMD reports for a given customer
 */
export const downloadImdReports = <ThrowOnError extends boolean = false>(options: Options<DownloadImdReportsData, ThrowOnError>) => (options.client ?? client).post<DownloadImdReportsResponses, DownloadImdReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/imdreports/download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets infraservice series data for a customer.
 *
 * Selection contract: at most one `facilityKey` is supported. `groupId` is a legacy value from
 * an abandoned "customer-defined groups" feature; it is either `null` (unused) or `Guid.Empty`
 * (no restriction — use all of the customer's metering points). Combining a non-null `groupId` with
 * `facilityKey` or `meteringPointId` returns 400. Omitting `facilityKey`, `meteringPointId`
 * and `groupId` entirely is a valid, implicitly customer-wide request.
 */
export const getInfraserviceSeries = <ThrowOnError extends boolean = false>(options: Options<GetInfraserviceSeriesData, ThrowOnError>) => (options.client ?? client).get<GetInfraserviceSeriesResponses, GetInfraserviceSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/{infraService}',
    ...options
});

/**
 * Selection contract: at most one `facilityKey` is supported. Omitting `facilityKey` and
 * `meteringPointId` entirely is a valid, implicitly customer-wide request.
 */
export const getGroupedInfraserviceSeries = <ThrowOnError extends boolean = false>(options: Options<GetGroupedInfraserviceSeriesData, ThrowOnError>) => (options.client ?? client).get<GetGroupedInfraserviceSeriesResponses, GetGroupedInfraserviceSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/{infraService}/{groupBy}',
    ...options
});

/**
 * Gets an Excel consumption report for infraservice series data.
 *
 * Selection contract: at most one `facilityKey` is supported. `groupId` is a legacy value from
 * an abandoned "customer-defined groups" feature; it is either `null` (unused) or `Guid.Empty`
 * (no restriction — use all of the customer's metering points). Combining a non-null `groupId` with
 * `facilityKey` or `meteringPointId` returns 400. Omitting `facilityKey`, `meteringPointId`
 * and `groupId` entirely is a valid, implicitly customer-wide request.
 */
export const getInfraserviceSeriesConsumptionReport = <ThrowOnError extends boolean = false>(options: Options<GetInfraserviceSeriesConsumptionReportData, ThrowOnError>) => (options.client ?? client).get<GetInfraserviceSeriesConsumptionReportResponses, GetInfraserviceSeriesConsumptionReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/{infraService}/consumption/report',
    ...options
});

/**
 * Gets cost details for infraservice series data.
 *
 * Selection contract: at most one `facilityKey` is supported. `groupId` is a legacy value from
 * an abandoned "customer-defined groups" feature; it is either `null` (unused) or `Guid.Empty`
 * (no restriction — use all of the customer's metering points). Combining a non-null `groupId` with
 * `facilityKey` or `meteringPointId` returns 400. Omitting `facilityKey`, `meteringPointId`
 * and `groupId` entirely is a valid, implicitly customer-wide request.
 */
export const getCostDetailsForInfraserviceSeries = <ThrowOnError extends boolean = false>(options: Options<GetCostDetailsForInfraserviceSeriesData, ThrowOnError>) => (options.client ?? client).get<GetCostDetailsForInfraserviceSeriesResponses, GetCostDetailsForInfraserviceSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/{infraService}/costdetails',
    ...options
});

/**
 * Gets heating energy efficiency (Q/W or QW)-comparison data for customer
 */
export const getCustomerEnergyEfficiencyMeterValues = <ThrowOnError extends boolean = false>(options: Options<GetCustomerEnergyEfficiencyMeterValuesData, ThrowOnError>) => (options.client ?? client).get<GetCustomerEnergyEfficiencyMeterValuesResponses, GetCustomerEnergyEfficiencyMeterValuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/{infraService}/qw',
    ...options
});

export const getMonthlyConsumptionOfCustomerReport = <ThrowOnError extends boolean = false>(options: Options<GetMonthlyConsumptionOfCustomerReportData, ThrowOnError>) => (options.client ?? client).get<GetMonthlyConsumptionOfCustomerReportResponses, GetMonthlyConsumptionOfCustomerReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/{utilityType}/consumption/monthly/report',
    ...options
});

export const getInfraserviceSeriesAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetInfraserviceSeriesAnalysisData, ThrowOnError>) => (options.client ?? client).get<GetInfraserviceSeriesAnalysisResponses, GetInfraserviceSeriesAnalysisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/analysis',
    ...options
});

/**
 * Get power peaks by provided start date and optional end date
 *
 * Get power peaks by provided start date and optional end date.
 * Will only act on year + month and ignore any provided day.
 * Returns the 3 highest power peaks of each month.
 * <Br />
 * Low tariff power peaks:
 * <Br />
 * - [April - October]: Whole period is low tariff.
 * - [November - March]: All times between [20-7).
 * I.e. Start: [20, 7), End: (20, 7) Where End is not greater than start.
 * <Br /><Br />
 * High tariff power peaks:
 * <Br />
 * - [November - March]: Weekdays between, inclusively, [7-20].
 * I.e. Start: [7, 20), End: (7, 20) Where End is not greater than start.
 */
export const getPeakPowerConsumptionOfMeteringPoint = <ThrowOnError extends boolean = false>(options: Options<GetPeakPowerConsumptionOfMeteringPointData, ThrowOnError>) => (options.client ?? client).get<GetPeakPowerConsumptionOfMeteringPointResponses, GetPeakPowerConsumptionOfMeteringPointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeries/el/peakpowerconsumption',
    ...options
});

/**
 * Gets infraservice series data for one or more year/month periods.
 *
 * Selection contract: at most one `facilityKey` is supported. Omitting `facilityKey` and
 * `meteringPointId` entirely is a valid, implicitly customer-wide request.
 */
export const getInfraserviceSeriesFromTimeTable = <ThrowOnError extends boolean = false>(options: Options<GetInfraserviceSeriesFromTimeTableData, ThrowOnError>) => (options.client ?? client).get<GetInfraserviceSeriesFromTimeTableResponses, GetInfraserviceSeriesFromTimeTableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/infraserviceSeriesFromTimeTable/{infraService}',
    ...options
});

/**
 * Get invoice document
 */
export const getInvoiceDocument = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceDocumentData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceDocumentResponses, GetInvoiceDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/invoices/{invoiceNumber}/document',
    ...options
});

/**
 * Compare customer metervalues against average consumption (from last month) grouped by category
 */
export const getGroupedCustomerMeterValuesCompare = <ThrowOnError extends boolean = false>(options: Options<GetGroupedCustomerMeterValuesCompareData, ThrowOnError>) => (options.client ?? client).get<GetGroupedCustomerMeterValuesCompareResponses, GetGroupedCustomerMeterValuesCompareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/metervalues/compareGrouped',
    ...options
});

/**
 * Gets peak power consumption cost for a specific date
 */
export const getPeakPowerCostCalculation = <ThrowOnError extends boolean = false>(options: Options<GetPeakPowerCostCalculationData, ThrowOnError>) => (options.client ?? client).get<GetPeakPowerCostCalculationResponses, GetPeakPowerCostCalculationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/metervalues/peakPowerCost',
    ...options
});

/**
 * Gets daily peak power consumption overview data for a specific month
 */
export const getPeakPowerDailyOverview = <ThrowOnError extends boolean = false>(options: Options<GetPeakPowerDailyOverviewData, ThrowOnError>) => (options.client ?? client).get<GetPeakPowerDailyOverviewResponses, GetPeakPowerDailyOverviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/metervalues/peakPowerDailyOverview',
    ...options
});

/**
 * Gets peak power consumption data for a specific month
 */
export const getPeakPowerHourlyOverview = <ThrowOnError extends boolean = false>(options: Options<GetPeakPowerHourlyOverviewData, ThrowOnError>) => (options.client ?? client).get<GetPeakPowerHourlyOverviewResponses, GetPeakPowerHourlyOverviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/metervalues/peakPowerHourlyOverview',
    ...options
});

export const getParentOrganization = <ThrowOnError extends boolean = false>(options: Options<GetParentOrganizationData, ThrowOnError>) => (options.client ?? client).get<GetParentOrganizationResponses, GetParentOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/organization/parent',
    ...options
});

/**
 * Get report configurations for customer
 */
export const getReportConfigurationList = <ThrowOnError extends boolean = false>(options: Options<GetReportConfigurationListData, ThrowOnError>) => (options.client ?? client).get<GetReportConfigurationListResponses, GetReportConfigurationListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reportconfigurations',
    ...options
});

/**
 * Creates a new reportConfiguration
 */
export const createReportConfiguration = <ThrowOnError extends boolean = false>(options: Options<CreateReportConfigurationData, ThrowOnError>) => (options.client ?? client).post<CreateReportConfigurationResponses, CreateReportConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reportconfigurations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a reportConfig
 */
export const deleteReportConfiguration = <ThrowOnError extends boolean = false>(options: Options<DeleteReportConfigurationData, ThrowOnError>) => (options.client ?? client).delete<DeleteReportConfigurationResponses, DeleteReportConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reportconfigurations/{id}',
    ...options
});

/**
 * Get report configuration
 */
export const getReportConfiguration = <ThrowOnError extends boolean = false>(options: Options<GetReportConfigurationData, ThrowOnError>) => (options.client ?? client).get<GetReportConfigurationResponses, GetReportConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reportconfigurations/{id}',
    ...options
});

/**
 * Update a reportConfiguration
 */
export const updateReportConfiguration = <ThrowOnError extends boolean = false>(options: Options<UpdateReportConfigurationData, ThrowOnError>) => (options.client ?? client).put<UpdateReportConfigurationResponses, UpdateReportConfigurationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reportconfigurations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get report configuration Excel
 */
export const getReportExcel = <ThrowOnError extends boolean = false>(options: Options<GetReportExcelData, ThrowOnError>) => (options.client ?? client).get<GetReportExcelResponses, GetReportExcelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reportconfigurations/{id}/run',
    ...options
});

/**
 * Get facility report in Excel-format.
 */
export const getFacilityExcelReport = <ThrowOnError extends boolean = false>(options: Options<GetFacilityExcelReportData, ThrowOnError>) => (options.client ?? client).get<GetFacilityExcelReportResponses, GetFacilityExcelReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/facilities',
    ...options
});

/**
 * Gets consumption report based on Infraserviceseries data in Excel-format pivoted as the "heat map" in front end.
 *
 * Selection contract: at most one `facilityKey` is supported. `groupId` is a legacy value from
 * an abandoned "customer-defined groups" feature; it is either `null` (unused) or `Guid.Empty`
 * (no restriction — use all of the customer's metering points). Combining a non-null `groupId` with
 * `facilityKey` or `meteringPointId` returns 400. Omitting `facilityKey`, `meteringPointId`
 * and `groupId` entirely is a valid, implicitly customer-wide request.
 */
export const getInfraserviceSeriesReportExcel = <ThrowOnError extends boolean = false>(options: Options<GetInfraserviceSeriesReportExcelData, ThrowOnError>) => (options.client ?? client).get<GetInfraserviceSeriesReportExcelResponses, GetInfraserviceSeriesReportExcelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/infraserviceseries/{infraService}',
    ...options
});

/**
 * Get invoice details report in Excel-format.
 */
export const getInvoiceDetailsExcelReport = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceDetailsExcelReportData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceDetailsExcelReportResponses, GetInvoiceDetailsExcelReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/invoicedetails',
    ...options
});

/**
 * Get invoice report in Excel-format.
 */
export const getInvoiceReferenceReportExcel = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceReferenceReportExcelData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceReferenceReportExcelResponses, GetInvoiceReferenceReportExcelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/invoices',
    ...options
});

/**
 * Create an consumption report for a specific organization, including sub organizations
 *
 * Only allowed for organizations with sub organizations, for all other use /report/consumption
 */
export const createOrganizationConsumptionReport = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationConsumptionReportData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationConsumptionReportResponses, CreateOrganizationConsumptionReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/organization/consumption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an facility report for a specific organization, including sub organizations
 *
 * Only allowed for organizations with sub organizations, for all other use /report/invoicedetails
 */
export const createOrganizationFacilityReport = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationFacilityReportData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationFacilityReportResponses, CreateOrganizationFacilityReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/organization/facilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an invoice details report for a specific organization, including sub organizations
 *
 * Only allowed for organizations with sub organizations, for all other use /report/invoicedetails
 */
export const createOrganizationInvoiceDetailsReport = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationInvoiceDetailsReportData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationInvoiceDetailsReportResponses, CreateOrganizationInvoiceDetailsReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/organization/invoicedetails',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an invoice report for a specific organization, including sub organizations
 *
 * Only allowed for organizations with sub organizations, for all other use /report/invoices
 */
export const createOrganizationInvoiceReport = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationInvoiceReportData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationInvoiceReportResponses, CreateOrganizationInvoiceReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/organization/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets consumption report based on metering point relations. The report is in Excel-format and holds consumption values (kWh and kVArh) for each child metering point.
 */
export const getSpecialTimeSeriesReport = <ThrowOnError extends boolean = false>(options: Options<GetSpecialTimeSeriesReportData, ThrowOnError>) => (options.client ?? client).get<GetSpecialTimeSeriesReportResponses, GetSpecialTimeSeriesReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reports/specialTimeSeries',
    ...options
});

/**
 * Get report templates
 */
export const getReportTemplates = <ThrowOnError extends boolean = false>(options: Options<GetReportTemplatesData, ThrowOnError>) => (options.client ?? client).get<GetReportTemplatesResponses, GetReportTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerId}/reporttemplates',
    ...options
});

/**
 * Get customer panel participation status
 */
export const getCustomerPanelParticipation = <ThrowOnError extends boolean = false>(options: Options<GetCustomerPanelParticipationData, ThrowOnError>) => (options.client ?? client).get<GetCustomerPanelParticipationResponses, GetCustomerPanelParticipationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerNo}/panel-participation',
    ...options
});

/**
 * Updates the customer's panel participation status.
 */
export const updateCustomerPanelParticipation = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerPanelParticipationData, ThrowOnError>) => (options.client ?? client).put<UpdateCustomerPanelParticipationResponses, UpdateCustomerPanelParticipationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/customers/{customerNo}/panel-participation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * To download a file given a token.
 */
export const downloadFile = <ThrowOnError extends boolean = false>(options: Options<DownloadFileData, ThrowOnError>) => (options.client ?? client).post<DownloadFileResponses, DownloadFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getHanPortsForCustomer = <ThrowOnError extends boolean = false>(options: Options<GetHanPortsForCustomerData, ThrowOnError>) => (options.client ?? client).get<GetHanPortsForCustomerResponses, GetHanPortsForCustomerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/hanport/{customerId}',
    ...options
});

export const changeHanPortStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeHanPortStatusData, ThrowOnError>) => (options.client ?? client).put<ChangeHanPortStatusResponses, ChangeHanPortStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/hanport/{meteringPointId}/{openOrClose}',
    ...options
});

export const getHanPortStatus = <ThrowOnError extends boolean = false>(options: Options<GetHanPortStatusData, ThrowOnError>) => (options.client ?? client).get<GetHanPortStatusResponses, GetHanPortStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/hanport/{meteringPointId}/status',
    ...options
});

/**
 * Get all helpdesk cases for customer.
 */
export const getCases = <ThrowOnError extends boolean = false>(options: Options<GetCasesData, ThrowOnError>) => (options.client ?? client).get<GetCasesResponses, GetCasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/messages',
    ...options
});

export const postMessage = <ThrowOnError extends boolean = false>(options?: Options<PostMessageData, ThrowOnError>) => (options?.client ?? client).post<PostMessageResponses, PostMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get all available case types.
 */
export const getCaseTypes = <ThrowOnError extends boolean = false>(options?: Options<GetCaseTypesData, ThrowOnError>) => (options?.client ?? client).get<GetCaseTypesResponses, GetCaseTypesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/messages/caseTypes',
    ...options
});

export const postMissingValuesMessage = <ThrowOnError extends boolean = false>(options?: Options<PostMissingValuesMessageData, ThrowOnError>) => (options?.client ?? client).post<PostMissingValuesMessageResponses, PostMissingValuesMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/messages/notifyMissingValues',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get all available options for a given message type.
 */
export const getOptions = <ThrowOnError extends boolean = false>(options?: Options<GetOptionsData, ThrowOnError>) => (options?.client ?? client).get<GetOptionsResponses, GetOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/messages/options',
    ...options
});
